import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Box, Button, Typography } from "@mui/material";

import Banner from "../generalBanner/Banner";
import ContainerTemplate from "../generalContainer/ContainerTemplate";
import HaveQuestions from "../../components/HaveQuestions";
import WhyProduct from "./WhyProduct";
import RealImpact from "./RealImpact";
import OurProcess from "./OurProcess";

// Product Agnostic Container
import BalanceOutlinedIcon from "@mui/icons-material/BalanceOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";

// Our Approach Container
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import HeightOutlinedIcon from "@mui/icons-material/HeightOutlined";

// Banner
import bgImage from "../../assets/productAgnosticBg.png";
const bannerTitle = "Technology-Agnostic DAM Solutions Built Around Your Needs";
const bannerDesc =
  "We don’t sell tools—we design the right DAM ecosystem tailored to your business goals.";

// Product Agnostic Container
const productAgnosticTitle = "What “Product Agnostic” Really Means";
const productAgnosticDesc =
  "Being product agnostic means we focus entirely on your business goals—not on promoting any specific DAM platform. We evaluate multiple tools, technologies, and integrations to recommend the solution that truly fits your workflows, scale, and future vision.";
const productAgnosticCards = [
  {
    title: "No Vendor Bias",
    description: "We recommend what's best—not what we sell.",
    icon: BalanceOutlinedIcon,
  },
  {
    title: "Tailored Solutions",
    description: "Every recommendation is aligned to your needs.",
    icon: ExtensionOutlinedIcon,
  },
  {
    title: "Future Flexibility",
    description: "Easily adapt and scale as your business grows.",
    icon: TrendingUpOutlinedIcon,
  },
];

// Our Approach Container
const ourApproachTitle = "Our Approach";
const ourApproachDesc = "How We Deliver Product-Agnostic Value";
const ourApproachCards = [
  {
    title: "Requirement-First Strategy",
    description: "We deeply understand your workflows before suggesting tools.",
    icon: FactCheckOutlinedIcon,
  },
  {
    title: "Multi-Vendor Expertise",
    description: "Experience across leading DAM platforms.",
    icon: AccountTreeOutlinedIcon,
  },
  {
    title: "Technology Evaluation",
    description: "Compare tools based on features, scalability, and cost.",
    icon: SearchOutlinedIcon,
  },

  {
    title: "Integration-Ready Planning",
    description: "Ensure seamless integration with your ecosystem.",
    icon: ExtensionOutlinedIcon,
  },

  {
    title: "User-Centric Selection",
    description: "Focus on adoption, usability, and real workflows.",
    icon: HowToRegOutlinedIcon,
  },

  {
    title: "Long-Term Scalability",
    description: "Solutions built for future growth—not short-term fixes.",
    icon: HeightOutlinedIcon,
  },
];

const ProductAgnosticPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F9F9F9" }}>
      <Helmet>
        <title>DAM Journey - Product Agnostic</title>
        <meta
          name="description"
          content="Technology-Agnostic DAM Solutions Built Around Your Needs, We don’t sell tools—we design the right DAM ecosystem tailored to your business goals"
        />
        <meta
          property="keywords"
          content="DAM, DAM Journey, DAM Practice, DAM Consultant, DAM Consulting, DAM Practitioner, DAM Service, DAM Product, DAM Discovery, DAM Implementation, DAM Deployment, Technology-Agnostic DAM Solutions Built Around Your Needs"
        />
      </Helmet>
      <Box /*sx={{ maxWidth: "1440px" }}*/>
        <Banner title={bannerTitle} description={bannerDesc} image={bgImage} />
        <ContainerTemplate
          title={productAgnosticTitle}
          description={productAgnosticDesc}
          cardsData={productAgnosticCards}
        />
        <ContainerTemplate
          title={ourApproachTitle}
          description={ourApproachDesc}
          cardsData={ourApproachCards}
        />
        <WhyProduct />
        <RealImpact />
        <OurProcess />

        {/* Have Questions Section */}
        <HaveQuestions />
      </Box>
    </Box>
  );
};

export default ProductAgnosticPage;
